import { DEFAULT_LANG } from "constants/config";
import useClerkMetadata from "features/User/hooks/useClerkMetadata";
import { LangCodeType } from "helpers/language";

function useUserSettings() {
  const { userMetadata, updateUserMetadata, isUserMetadataLoaded } =
    useClerkMetadata();

  const settings = userMetadata?.settings ?? {};

  const setSearchLanguage = async (lang: LangCodeType) => {
    // Fix for bad language code push
    if (lang === "ch") {
      lang = "zh";
    }

    // If language is default, remove it from settings
    const newSettings = { ...settings };
    if (lang === DEFAULT_LANG) {
      delete newSettings.lang;
    } else {
      newSettings.lang = lang;
    }

    updateUserMetadata({
      settings: newSettings,
    });
  };

  const setLibraryId = async (libraryId: string | null) => {
    const newSettings = { ...settings };
    if (libraryId === null) {
      delete newSettings.library_id;
    } else {
      newSettings.library_id = libraryId;
    }

    updateUserMetadata({
      settings: newSettings,
    });
  };

  return {
    isSettingsLoaded: isUserMetadataLoaded,
    ...settings,
    setSearchLanguage,
    setLibraryId,
  };
}

export default useUserSettings;
